export class OrderWon {
    OrderWonID: number;
    OrderWonName: string;
    OrderWonDescription: string;
    IsActive: boolean = true;
    ModifiedBy: number;
}
